<template>
  <div class="" :class = "{'clear-header':isWechatBrowser}">
    <my-header :title="stageName" v-if="!isWechatBrowser" :showBack="true"></my-header>
    <div v-if="stageStatus == '3'" class="stage-info border-bottom-style">
      <div>验收时间</div>
      <div class="stage-status" >{{inspectTime | shortTime}}</div>
    </div>
      <div class="stage-info">
        <div>阶段状态</div>
        <div class="stage-status" v-if="stageStatus == '2'">验收中</div>
        <div class="stage-status" v-if="stageStatus == '3'">验收完</div>
      </div>
      <section class="node-page-part">
        <div v-for="(category,categoryIndex) in categoryList" class="category-content">
          <div class="category">
            <div class="category-name">{{category.name}}</div>
            <div v-for="(projectNode,nodeIndex) in category.onestopProjectNodeList">
              <div class="record-content">
                <span class="node-content">
                  <span style="margin: 2px 5px 0px 0px">{{projectNode.nodeNumber}}.</span>
                  <span>{{projectNode.nodeContent}}</span>
                </span>
                <span style="margin: 5px" v-if="projectNode.status == '1'">
                  <img class="node-icon" v-if="projectNode.score == '1'" src="../../assets/onestop/node-score-1.png"/>
                  <img class="node-icon" v-if="projectNode.score == '2'" src="../../assets/onestop/node-score-2.png"/>
                  <img class="node-icon" v-if="projectNode.score == '3'" src="../../assets/onestop/node-score-3.png"/>
                  <img class="node-icon" v-if="projectNode.score == '4'" src="../../assets/onestop/node-score-4.png"/>
                  <img class="node-icon" v-if="projectNode.score == '5'" src="../../assets/onestop/node-score-5.png"/>
                  <img class="node-icon" v-if="projectNode.score == '6'" src="../../assets/onestop/node-score-6.png"/>
                  <img class="node-icon" v-if="projectNode.score == '7'" src="../../assets/onestop/node-score-7.png"/>
                </span>
                <span style="margin: 5px" v-if="projectNode.status != '1'">
                  <img class="node-icon" src="../../assets/icon_wrong.png"/>
                </span>
              </div>
              <div class="record-img" v-if="projectNode.recordImageList">
                <div class="image-area">
                  <div class="image-view">
                    <div v-for="(recoredImg,index) in projectNode.recordImageList">
                      <div class="image" v-if="recoredImg.key == projectNode.id" :data-index="index" style="position: relative">
                        <img :src="recoredImg.value" >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </section>
      <mt-popup v-model="popupVisible" popup-transition="popup-fade"  position="right" style="width: 30%;background-color: #26a2ff;border-radius: 4px">
        <div class="bank-list">
          <div v-for="(value,key) in nodeScoreMap" class="nodeScore-content" @click="selectIt(key,value)">
            <div class="nodeScore">
              <span style="color: white">{{ value}}</span>
            </div>
          </div>
        </div>
      </mt-popup>
    <mt-actionsheet :actions="actions" v-model="sheetVisible"></mt-actionsheet>
    <preview :show="showPreview" :options="recordImagess" :dis="previewIndex" @on-close="hideImageView"></preview>
  </div>
</template>
<script>
  import onestopProjectService from '../../service/onestop/OnestopProjectService';
  import {Toast, Indicator} from 'mint-ui';
  import Header from '../../components/header/Header'
  import Preview from '../../components/preview/preview'

  export default {
    name: 'OnestopProjectNodeList',
    components: {
      'my-header': Header,
      'preview':Preview
    },
    data () {
      return {
        projectId:null,
        stageId:null,
        projectNodeId:null,
        categoryList:{},
        nodeScoreMap:[],
        popupVisible:false,
        recordImagess:[],
        showPreview:false,
        previewIndex:0,
        actions:[],
        sheetVisible:false,
        nodeNums:[],
        projectNode:{},
        recordImageList:[],
        projectDetail:{},
        superVisor:{},
        stageStatus:'',
        stageName:'',
        inspectTime:'',
        isWechatBrowser:this.$verfyBrowserType(),
      }
    },
    created(){
      global.baseImageUrl = 'https://img.shuimujiaju.com/';
      this.projectId = this.$route.query.projectId;
      this.stageId = this.$route.query.stageId;
      this.stageStatus = this.$route.query.stageStatus;
      document.title = this.$route.query.stageName;
      this.stageName = this.$route.query.stageName;
      this.inspectTime = this.$route.query.inspectTime;
    },
    beforeMount () {
      this.getProjectNodeList(this.projectId,this.stageId)
    },
    methods: {
      async getProjectNodeList(projectId,stageId){
        let {code,msg,data} = await onestopProjectService.nodeList(projectId,stageId);
        if(code == '0'){
          this.categoryList = data.categoryList;
          this.nodeScoreMap = data.nodeScoreMap;
          this.projectDetail = data.onestopProject;
        }else {
          Toast(msg);
        }

      },
      selectBankPop(categoryIndex,nodeIndex,id) {
        global.categoryIndex = categoryIndex;
        global.nodeIndex = nodeIndex
        this.projectNodeId = id;
        this.popupVisible = true;
      },
      selectIt(key,score) {
        //保存节点信息
        var node = this.categoryList[global.categoryIndex].onestopProjectNodeList[global.nodeIndex];
        var projectNode = Object();
        projectNode.id = this.projectNodeId;
        projectNode.score = key;
        if(node.recordImages){
          projectNode.recordImages = node.recordImages;
        }
        onestopProjectService.nodeSave(projectNode);
        //修改节点的值
        var projectNodeShow = this.categoryList[global.categoryIndex].onestopProjectNodeList[global.nodeIndex];
        projectNodeShow.score = key;
        this.popupVisible = false;
      },
      optionImage(categoryIndex,nodeIndex,index,event){
        var that = this;
        this.actions = [
//          {
//          name: '查看',
//          method: () =>{
//            this.previewImage(categoryIndex,nodeIndex,index,event);
//          }
//        },
        ];
        this.sheetVisible = true;
      },
      previewImage(categoryIndex,nodeIndex,index,event){
        this.recordImagess = this.categoryList[categoryIndex].onestopProjectNodeList[nodeIndex];
        this.previewIndex = index;
        this.showPreview = true;
      },
      hideImageView(){
        this.showPreview = false;
        this.previewIndex = 0;
      },
      selectImage(){
        window.location.href = "chooser://selectImage";
        Indicator.open({
          text: '加载中...',
          spinnerType: 'fading-circle'
        });
      },
      openCamera(){
        window.location.href = "camera://selectImage";
        Indicator.open({
          text: '加载中...',
          spinnerType: 'fading-circle'
        });
      }
    }
  }

</script>
<style lang="scss">
  @import '../../assets/style/common.scss';
  .nodeScore-content {
    font-size: 14px;
    padding: 10px 15px;
    border-bottom: 1px solid #3c95ff;
    text-align: center;
  }
  .clear-header{
    margin-top: -1rem;
  }
  .stage-info{
    display: flex;
    justify-content: space-between;
    font-size: 0.28rem;
    color: #1b1e29;
    height: 0.86rem;
    padding-right: 0.3rem;
    margin-left: 0.3rem;
    line-height: 0.86rem;
    .stage-status{
      color: #878e99;
    }
  }
  .node-page-part{
    text-align: left;
    margin-top: 10px;
    background-color: white;
  }
  .image-tip{
    font-size: 15px;
    padding: 5px 5px;
    margin-bottom: 5px;
    background-color: #FEE7B3;
    color: #b3854a
  }
  .category{
    background-color: white;
  }
  .category-name{
    background-color:#F3F8FC;
    font-size: 0.28rem;
    color: #1b1e29;
    height: 0.9rem;
    line-height: 0.91rem;
    padding-left: 0.3rem;
  }
  .record-content{
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
    font-size: 0.28rem;
    color: #1b1e29;
    padding-left: 0.3rem;
    padding-right: 0.3rem;
  }
  .node-content{
    display: flex;
    justify-content: flex-start;
  }
  .node-icon{
    width: 15px;
    height: 15px
  }
  .image-area{
    background-color: #fff;
    width: 100%;
  .image-view{
    display: flex;
    flex-flow: row wrap;
    padding:0.3rem 14px;
    padding-right:0px;
    .image{
      width:1.64rem;
      height: 1.64rem;
      background: #F3F8FC;
      margin-bottom: 5px;
      margin-right:14px;
      &.add-image{
         display: flex;
         flex-flow: row wrap;
         justify-content: center;
         align-items: center;
         color: #999;
       }
      .icon-plus img{
        width: 0.8rem;
        height: 0.8rem;
        position: relative;
      }
      img{
        width: 100%;
        height: 100%;
      }
    }

  }
  .image-tip{
    padding:10px;
    font-size: 14px;
    color: #999999;
  }
  }

  .nodeScore-content {
    padding: 10px 15px;
    border-bottom: 1px solid #3c95ff;
    text-align: center;
  }
</style>
